/**
 * Mentor portal breadcrumb trailing actions.
 * Help / Notifications are not shipped — show disabled chrome with honest tooltips.
 * Native `disabled` suppresses title tooltips in some browsers, so wrap with a titled span.
 */
const MentorChromeActions = () => (
    <div className="d-flex align-items-center gap-2 text-secondary font-12">
        <span title="Help is not available yet" className="d-inline-block">
            <button
                type="button"
                className="btn btn-sm btn-light border-0"
                disabled
                aria-disabled="true"
                aria-label="Help is not available yet"
            >
                <i className="bi bi-question-circle" aria-hidden="true"></i>
            </button>
        </span>
        <span title="Notifications are not available yet" className="d-inline-block">
            <button
                type="button"
                className="btn btn-sm btn-light border-0"
                disabled
                aria-disabled="true"
                aria-label="Notifications are not available yet"
            >
                <i className="bi bi-bell" aria-hidden="true"></i>
            </button>
        </span>
    </div>
);

export default MentorChromeActions;
